const mutations = {
    SET_NAME(state, params){
        state.name = params
    }
}

export default mutations